// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2nEf5","right":"Footer_right__1RIBX","buttons":"Footer_buttons__DyfVx"};